<template>
    <div>
        <pagination-component
            :pagination="pagination"
            :key="'pagination-1-'+ (pagination.current_page ? pagination.current_page : 1) + pagination.total"
        ></pagination-component>
        <table class="table simple-table table-striped table-sm mb-0 table-bordered" style="font-size:0.8em;">
            <thead class="thead-dark">
            <tr>
                <th class="report-record" scope="col">{{$lang('ID')}}</th>
                <th class="report-record" scope="col">{{$lang('Nr zadania')}}</th>
                <th class="report-record" scope="col" style="min-width: 100px">{{$lang('Data zgłoszenia')}}</th>
                <th class="report-record" scope="col">{{$lang('Biblioteka')}}</th>
                <th class="report-record" scope="col">{{$lang('Osoba zgłaszająca')}}</th>
                <th class="report-record" scope="col">{{$lang('Temat')}}</th>
                <th class="report-record" scope="col">{{$lang('Opis')}}</th>
                <th class="report-record" scope="col">{{$lang('Moduł')}}</th>
            </tr>
            </thead>
            <tbody>

            <tr v-if="pagination.total === 0" class="table-light">
                <th colspan="8">{{$lang('Brak zgłoszeń.')}}</th>
            </tr>

            <template v-else v-for="(task, index) in pagination.data">
                <tr v-if="index ===0 || task.criterion !== pagination.data[index-1].criterion">
                    <th class="report-record" colspan="8">{{task.criterionName}}</th>
                </tr>

                <tr>
                    <td class="report-record" :data-title="$lang('ID')"><a :href="'/task/' + task.id">{{task.id}}</a>
                    </td>
                    <td class="report-record" :data-title="$lang('Nr zadania')">
                        <a v-if="task.jira_id" :href="jira_link + task.jira_id" target="_blank">{{task.jira_id}}</a>
                        <a v-else-if="task.ptd_id" :href="ptd_link + task.ptd_id" target="_blank">{{task.ptd_id}}</a>
                        <span v-else> - </span>
                    </td>
                    <td class="report-record"
                        :data-title="$lang('Data')">{{task.created_at_showable}}
                    </td>
                    <td style="text-align: left" class="report-record" :data-title="$lang('Biblioteka')">
                        <span v-if="!task.for_all">{{task.libraryName}}</span>
                        <span v-else>{{$lang('Wszystkie')}}</span>
                    </td>
                    <td style="text-align: left" class="report-record" :data-title="$lang('Osoba zgłaszająca')">
                        {{task.personName +' '+ task.personSurname}}
                    </td>
                    <td style="text-align: left" class="report-record" :data-title="$lang('Temat')">{{task.subject_alternative}}
                    </td>
                    <td style="text-align: justify" class="report-record" :data-title="$lang('Opis')">
                        {{task.description}}
                    </td>
                    <td class="report-record" :data-title="$lang('Moduł')">{{task.moduleName}}</td>
                </tr>
            </template>

            </tbody>
        </table>
        <pagination-component
            :pagination="pagination"
            :key="'pagination-2-'+ (pagination.current_page ? pagination.current_page : 1) + pagination.total"
        ></pagination-component>
    </div>
</template>

<script>
    export default {
        name: 'tasks-by-criterion-table',
        props: {
            pagination: Object,
            jira_link: String,
            ptd_link: String
        }
    }
</script>
